import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

interface DeleteConfirmDialogProps {
  open: boolean
  isDeletingThread: boolean
  onClose: () => void
  onConfirm: () => void
}

export default function DeleteConfirmDialog({ open, isDeletingThread, onClose, onConfirm }: DeleteConfirmDialogProps) {
  return <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete Confirmation</DialogTitle>
    <DialogContent>
      <DialogContentText>Are you sure you want to delete this thread and all its history? This action cannot be undone.</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} color="warning" loading={isDeletingThread}>Delete</Button>
    </DialogActions>
  </Dialog>
}
